import { Component, OnInit, Optional, Inject, ViewChild } from "@angular/core";
import { CampaignMaintenanceService } from "src/app/pages/maintenance/campaign-maintenance/campaign-maintenance.service";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { DistributionSelectorComponent } from "./distribution-selector/distribution-selector.component";
import { CampaignsService } from "src/app/pages/campaign-module/campaigns/campaigns.service";
import { CampaignSelectorComponent } from "./campaign-selector/campaign-selector.component";
import { DistributionPromoDetailSku } from "src/app/model/distribution-promo-sku";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { StepThreeComponent } from "./step-three/step-three.component";
import { DistributionPromo } from "src/app/model/distribution-promo";
import { StepFourComponent } from "./step-four/step-four.component";
import { DialogService, LanguageService } from "src/app/services";
import { StepOneComponent } from "./step-one/step-one.component";
import { StepTwoComponent } from "./step-two/step-two.component";
import { PromoCondition } from "src/app/model/promo-condition";
import { environment } from "src/environments/environment";
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from "@angular/flex-layout";
import { catchError, finalize } from "rxjs/operators";
import { Category } from "src/app/model/category";
import { Brand } from "src/app/model/brand";
import { Sku } from "src/app/model/sku";
import * as moment from 'moment';
import * as _ from "lodash";
import { StepperSelectionEvent } from "@angular/cdk/stepper";

@Component({
  selector: "esc-campaign-wizard",
  templateUrl: "./campaign-wizard.component.html",
  styleUrls: ["./campaign-wizard.component.scss"]
})
export class CampaignWizardComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;
  @ViewChild("stepOne") stepOne: StepOneComponent;
  @ViewChild("stepTwo") stepTwo: StepTwoComponent;
  @ViewChild("stepThree") stepThree: StepThreeComponent;
  @ViewChild("stepFour") stepFour: StepFourComponent;
  @ViewChild("campaignSelector") campaignSelector: CampaignSelectorComponent;
  @ViewChild("distributionSelector") distributionSelector: DistributionSelectorComponent;

  allCategoriesSelected = false;
  allBrandsSelected = false;
  allItemsSelected = false;

  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  options1 = ["Category", "Branch", "SKU"];
  selectedCampaign;
  selectedDistribution;
  loadingCampaign;
  loadingDistribution;
  disableCampaignSelector;
  disableStepOneForm;
  disabledByBackBtn;
  disableCouponGeneration = true;
  viewMode;
  editMode;
  private listSub: Subscription;
  
  constructor(
    public media: MediaObserver,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private campaignsService: CampaignsService,
    private campaignMntService: CampaignMaintenanceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CampaignWizardComponent>,
  ) {}

  ngOnInit() {
    this.viewMode = _.get(this.data, "mode") == "view" ? true : false;
    this.editMode = _.get(this.data, "mode") == "edit" ? true : false;
    this.disabledByBackBtn = false;
    this.resetSteps();

    if (this.editMode || this.viewMode) {
      this.getCampaignDetail()
    }

    if (this.viewMode) {
      this.disableStepOne();
    } else {
      this.enableStepOne();
    }
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  // Reset variables used in steps
  resetSteps() {
    this.campaignsService.resetStepTwoResponse();
  }
  
  disableStepOne() {
    this.disableCampaignSelector = true;
    this.disableStepOneForm = true;
  }

  enableStepOne() {
    this.disableCampaignSelector = false;
    this.disableStepOneForm = false;
  }

  loadingCampaignData(ev) {
    this.loadingCampaign = ev;
  }

  loadingDistributionData(ev) {
    this.loadingDistribution = ev;
  }

  getCouponQty(ev) {
    this.disableCouponGeneration =  ev ? false : true;
  }

  confirmBackStep() {
    if(this.stepTwo.formGroup.untouched) {
      this.stepper.previous();
    } 
    else {
      this.dialogService
      .openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_UNSAVED_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          for(let i in this.stepTwo.multiSelect) {
            if (['selectedWebUser', 'selectedRecipient'].includes(i)) {
              this.stepTwo.multiSelect[i] = [];
            } else {
              this.stepTwo.multiSelect[i] = [this.stepTwo.defaultOption];
            }
          }

          for(let i in this.stepTwo.formGroup.controls) {
            this.stepTwo.formGroup.controls[i].enable();
            if (['web_user', 'recipient'].includes(i)) {
              this.stepTwo.formGroup.controls[i].reset([], { emitEvent: false });
              this.stepTwo.chipsWebUser.errorState = false;
              this.stepTwo.chipsRecipient.errorState = false;
            } else if (['location_region', 'location_province', 'location_city', 'chain_type', 'chain', 'branch', 'item', 'brand', 'category'].includes(i)) {
              this.stepTwo.formGroup.controls[i].reset([0], { emitEvent: false });
            } else {
              this.stepTwo.formGroup.controls[i].reset(null, { emitEvent: false });
            }
          }

          this.stepTwo.formGroup.get('code').disable();
          this.distributionSelected(null);

          if (this.viewMode) {
            console.log("VIEW MODED!")
          }

          this.stepper.previous();
        }
      })
    }
  }

  campaignSelected(ev) {
    this.selectedCampaign = _.cloneDeep(ev);

    if (!this.viewMode) {
      this.distributionSelected(null);
    }
  }

  distributionSelected(ev) {
    this.selectedDistribution = _.cloneDeep(ev);
  }

  validateStepOne() {
    let validFlag = true;

    for (let key in this.stepOne.formGroup.value) {
      if (((key != 'code') && (key != 'description')) && !this.stepOne.formGroup.value[key]) {
        validFlag = false;
        break;
      }
      else if(((key != 'code') && (key != 'description')) && !this.selectedCampaign && (this.stepOne.formGroup.controls[key].valid == false)) {
        validFlag = false;
        break;
      }
    }

    if (validFlag) {
      const formGroupValue = this.stepOne.formGroup.value
      this.selectedCampaign = {
        id: this.selectedCampaign ? this.selectedCampaign.id : 0,
        code: this.selectedCampaign ? this.selectedCampaign.code : "",
        description: formGroupValue.description,
        reference_filename: formGroupValue.reference_filename,
        start_date: moment(formGroupValue.start_date).format('YYYY-MM-DD 00:00:00'),
        end_date: moment(formGroupValue.end_date).format('YYYY-MM-DD 23:59:59'),
        reversal_number_of_days: formGroupValue.reversal_number_of_days,
        campaign_sms_message: [
            {
                id: 0,
                type: "REGISTRATION_SUCCESS",
                message: formGroupValue.registration_success
            },
            {
                id: 0,
                type: "USER_ALREADY_REGISTERED",
                message: formGroupValue.user_already_registered
            },
            {
                id: 0,
                type: "ANOTHER_USER_REGISTERED",
                message: formGroupValue.another_user_registered
            },
            {
                id: 0,
                type: "USER_MAXED_COUPON",
                message: formGroupValue.user_maxed_coupon
            }
        ]
      }

      // If on add mode
      if (!this.editMode && !this.viewMode) {
        let loadingDialog = this.dialogService.loading();
        const description = this.stepOne.formGroup.get("description").value;
        this.campaignsService.getCampaignDetailsByName(description).subscribe({
          next: (res: any) => {
            loadingDialog.close();
            if (res.data?.id) {
              // Campaign with this description already exists
              this.stepOne.formGroup.get('description').setErrors({ exists: true });
              this.dialogService.openSnackBar(
                this.languageService.getTranslation('MSG_FILL_OUT_REQUIRED_FIELDS', {})
              );
              this.scrollToTop();
              return;
            }
            // Proceed to next step if campaign description is unique
            this.stepper.next();
          },
          error: (err) => {
            loadingDialog.close();
            if (environment.showLogs) {
              console.error('Error checking campaign name existence:', err);
            }
            return;
          }
        });
      } else {
        // Not in add mode, proceed immediately
        this.stepper.next();
      }

      if(this.editMode || this.viewMode) {
        this.getDistributionDetail()
      }
    } 
    else if (!validFlag) {
      for (let ctrl in this.stepOne.formGroup.controls) {
        this.stepOne.formGroup.controls[ctrl].markAsTouched();
        if(((ctrl != 'code') && (ctrl != 'description')) && this.stepOne.formGroup.controls[ctrl].disabled) {
          this.stepOne.formGroup.controls[ctrl].markAsTouched();
        }
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_FILL_OUT_REQUIRED_FIELDS", {}));
        this.scrollToTop();
      }
    }
  }

  insertCampaign() {
    let reqObj = {
      data: [
        {
          id: this.selectedCampaign.id,
          code: this.selectedCampaign.code,
          description: this.selectedCampaign.description,
          reference_filename: this.selectedCampaign.reference_filename,
          start_date: this.selectedCampaign.start_date,
          end_date: this.selectedCampaign.end_date,
          reversal_number_of_days: parseInt(this.selectedCampaign.reversal_number_of_days),
          is_active: 1,
          campaign_sms_message: this.selectedCampaign.campaign_sms_message
        }
      ]
    }
    let loadingDialog = this.dialogService.loading();
    this.campaignMntService.insert(reqObj).pipe(
      catchError((err) => {
        console.error(err);
        return observableOf(err);
      }),
      finalize(() => {
        loadingDialog.close();
        return observableOf({});
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.dialogService.openSnackBar(res?.error?.value || this.networkErrMsg);
          this.stepOne.formGroup.get('description').setErrors({ "exists": true });
          return;
        }
        if (_.has(res, 'success') && (_.get(res, 'success.count') > 0)) {
          let campaignData = _.get(res, 'success.results[0].details.object')
          this.selectedCampaign = campaignData;
          this.prepareStepTwoData(this.stepTwo.formGroup.getRawValue(), campaignData)
        } 
        return observableOf({});
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
        return observableOf(null);
      });
  }

  validateStepTwo() {
    this.validateMultiSelects();
    if (this.stepTwo.formGroup.valid) {
      if (this.editMode || this.stepTwo.editMode) {
        this.insertCampaign();
        return;
      }

      // Validate muna yung distribution name if existing bago mag-insert
      this.campaignsService.validateDistributionName(this.stepTwo.formGroup.get("description").value).subscribe({
        next: (res: any) => {
          if (res && res.data && Object.keys(res.data).length > 0) {
            this.stepTwo.formGroup.get('description').setErrors({ "exists": true });
            this.dialogService.openSnackBar(this.languageService.getTranslation('MSG_FILL_OUT_REQUIRED_FIELDS', {}));
            this.scrollToTop();
          } else if (res && typeof res.data === 'object' && Object.keys(res.data).length === 0) {
            this.insertCampaign();
          } else {
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_DEFAULT", {}));
          }
        }
      })
    } else {
      for (let ctrl in this.stepTwo.formGroup.controls) {
        this.stepTwo.formGroup.controls[ctrl].markAsTouched();
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_FILL_OUT_REQUIRED_FIELDS", {}));
        this.scrollToTop();
      }


      const invalidControls = [];
      const controls = this.stepTwo.formGroup.controls;

      for (const name in controls) {
        if (controls[name].invalid) {
          invalidControls.push(name);
        }
      }

      console.log('Invalid controls:', invalidControls);
    }
  }

  prepareStepTwoData(formValues, campaignData) {
    let loadingDialog = this.dialogService.loading();
    //initial value is false
    this.allCategoriesSelected = false;
    this.allBrandsSelected = false;
    this.allItemsSelected = false;

    for (let key in formValues) {
      if (_.toLower(key).includes("date")) {
        formValues[key] = moment(formValues[key]).format("YYYY-MM-DD");
      }
    }
    
    let reqObj = {
      data: [
        {
          id: _.get(this.selectedDistribution, 'id', 0),
          code: _.get(formValues, 'code') || "",
          description: _.get(formValues, 'description'),
          redemption_printout_message: _.get(formValues, 'redemption_printout_message') || '',
          reversal_printout_message: _.get(formValues, 'reversal_printout_message') || '',
          show_groups_in_reports: _.get(formValues, 'show_groups_in_reports') ? 1 : 0,
          distribution_sku_mode: _.get(formValues, 'cat_brand_item.description') == 'Item' ? _.toUpper('SKU') : _.toUpper(_.get(formValues, 'cat_brand_item.description')),
          campaign_id: _.get(campaignData, 'id'),
          start_date: moment(_.get(formValues, 'red_start_date')).format('YYYY-MM-DD 00:00:00'),
          end_date: moment(_.get(formValues, 'red_end_date')).format('YYYY-MM-DD 23:59:59'),
          category_ids: _.get(formValues, 'category') || [0],
          brand_ids: _.get(formValues, 'brand') || [0],
          sku_ids: _.get(formValues, 'item') || [0],
          chain_type_ids: _.get(formValues, 'chain_type'),
          chain_ids: _.get(formValues, 'chain'),
          branch_ids: _.get(formValues, 'branch'),
          countries: _.get(formValues, 'location_country') || [0],
          regions:  _.get(formValues, 'location_region[0].code') != 'all' ? _.get(formValues, 'location_region') : [0],
          provinces: _.get(formValues, 'location_province[0].code') != 'all' ? _.get(formValues, 'location_province') : [0],
          cities: _.get(formValues, 'location_city[0].code') != 'all' ? _.get(formValues, 'location_city') : [0],
          generation_type: _.get(formValues, 'generation_type.code'),
          pre_generated_quantity: parseInt(_.get(formValues, 'pre_generated_qty')) || 0,
          on_demand_quantity: 0,
          expiry_date: _.get(formValues, 'exp_type') == "0" ? moment(_.get(formValues, 'exp_date')).format('YYYY-MM-DD 23:59:59') : null,
          expiry_max_usage_count: _.get(formValues, 'exp_type') == "1" ? 1 : 0,
          expiry_max_days_without_txn: _.get(formValues, 'exp_type') == "2" ? parseInt(_.get(formValues, 'num_of_days')) : null,
          expiry_max_days_from_first_purchase: _.get(formValues, 'exp_type') == "3" ? parseInt(_.get(formValues, 'num_of_days_from_first_purchase')) : null,
          is_initially_registered: _.get(formValues, 'act_type') == "0" ? 1 : 0,
          unregistered_allowed_usage_count: _.get(formValues, 'act_type') == "2" ? parseInt(_.get(formValues, 'num_of_txn')) : null,
          generate_active_coupon: _.get(formValues, 'generate_active_coupon') ? 1 : 0,
          unregistered_allowed_usable_date: _.get(formValues, 'act_type') == "1" ? moment(_.get(formValues, 'reg_deadline')).format('YYYY-MM-DD 23:59:59') : null,
          is_active: _.get(formValues, 'is_cancelled') == true ? 0 : 1,
          user_group_ids: _.get(formValues, 'web_user'),
          recipient_group_ids: _.get(formValues, 'recipient'),
        }
      ]
    }

    if(reqObj.data[0].category_ids == 0) {
      this.allCategoriesSelected = true;
    }
    if(reqObj.data[0].brand_ids == 0) {
      this.allBrandsSelected = true;
    }
    if(reqObj.data[0].sku_ids == 0) {
      this.allItemsSelected = true;
    } 

    this.listSub = this.campaignsService.submitStepTwo(reqObj)
    // .pipe(
    //   catchError((err) => {
    //     console.error(err);
    //     return observableOf(err);
    //   }),
    //   finalize(() => {
    //     loadingDialog.close();
    //     return observableOf({});
    //   }))
      .subscribe((res: any) => {
      if (environment.showLogs) {
        console.log(res);
      }
      loadingDialog.close();
      if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
        this.dialogService.openSnackBar(res?.error?.value || this.networkErrMsg);
        this.stepTwo.formGroup.get('description').setErrors({ "exists": true });
        return;
      }

      if (_.has(res, 'error') && (_.get(res, 'error.count') > 0) && (_.get(res.error, 'results[0].code') == 'E(221x1276)')) {
        this.dialogService.openSnackBar(_.get(res.error, 'results[0].value'));
        return;
      }
      if (_.has(res, 'success') && (_.get(res, 'success.count') > 0)) {
        this.campaignsService.setStepTwoResponse(_.get(res.success.results[0], 'details.object'));

        this.stepThree.categories = []
        this.stepThree.brands = []
        this.stepThree.items = [];

        const distributionSkuMode = this.stepTwo.formGroup.get("cat_brand_item").value.description;
        
        switch (distributionSkuMode) {
          case "Item":
            // Build list of items for step three, set to selected = true since res does not contain selected key
            this.stepTwo.multiSelect.selectedItems = _.get(res, 'success.results[0].details.object.skus');
            this.stepTwo.multiSelect.selectedItems.forEach(e => e.selected = true);
            this.stepThree.items = this.buildStepThreeItemsList(this.stepTwo.multiSelect.selectedItems);
            break;
          case "Brand":
            // Build list of brands for step three, set to selected = true since res does not contain selected key
            this.stepTwo.multiSelect.selectedBrands = _.get(res, 'success.results[0].details.object.brands');
            this.stepTwo.multiSelect.selectedBrands.forEach(e => e.selected = true);
            this.stepThree.brands = this.buildStepThreeBrandsList(this.stepTwo.multiSelect.selectedBrands);
            break;
          case "Category":
            // Build list of categories for step three, set to selected = true since res does not contain selected key
            this.stepTwo.multiSelect.selectedCategories = _.get(res, 'success.results[0].details.object.categories')
            this.stepTwo.multiSelect.selectedCategories.forEach(e => e.selected = true);
            this.stepThree.categories = this.buildStepThreeCategoriesList(this.stepTwo.multiSelect.selectedCategories);
            break;
          default:
            console.log('Unknown distributionSkuMode:', distributionSkuMode);
        }

        // Proceed to step three
        this.stepThree.initForm();
        this.stepThree.getConditions();
        this.stepThree.setStepTwoData({brand:formValues.brand,category:formValues.category,item:formValues.item});
        this.stepThree.setSourceData({brand:formValues.brand,category:formValues.category,item:formValues.item});
        this.stepThree.setDropDownOptions();
        this.stepper.next();
        this.listSub.unsubscribe();

        return observableOf({});
      }  
    }, err => {
      if (environment.showLogs) {
        console.error(err);
      }
      loadingDialog.close()
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_DEFAULT", {}));
      return observableOf(null);
    }, () => {
      this.listSub.unsubscribe();
    });
  }

  // Copied from old logic
  private buildStepThreeCategoriesList(selectedCategories) {
    // Initialize categories list
    const categories = [];

    // Add "All" first
    const newCategory = new Category();
    newCategory._id = 0;
    newCategory._description = "All";

    // Set "selected" property in DistributionPromoDetailSku
    const newCategoryDetail = new DistributionPromoDetailSku(0, 0, newCategory, null, null, this.allCategoriesSelected);
    newCategoryDetail._is_all = true;
    categories.push(newCategoryDetail);

    // Assumption is all of these are selected
    const isSelected = true;
    for (const category of selectedCategories) {
      if (category.description != "All") {
        const newCategory = new Category();
        newCategory._id = category.id;
        newCategory._description = category.description;

        const newCategoryDetail: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, newCategory, null, null, isSelected);
        categories.push(newCategoryDetail);
      }
    }

    if (environment.showLogs) {
      console.log("buildStepThreeCategoriesList: " + JSON.stringify(categories));
    }
    return categories;
  }

  private buildStepThreeBrandsList(selectedBrands) {
    // Initialize brands list
    const brands = [];

    // Add "All" first
    const newBrand = new Brand(0, "All");
    const newBrandDetail: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, newBrand, null);
    newBrandDetail._is_all = true;
    brands.push(newBrandDetail);

    // Add selected brands (skip "All")
    for (const brand of selectedBrands) {
      if (brand.description !== "All") {
        const newBrand = new Brand(brand.id, brand.description);
        const newBrandDetail = new DistributionPromoDetailSku(0, 0, null, newBrand, null);
        brands.push(newBrandDetail);
      }
    }

    if (environment.showLogs) {
      console.log("buildStepThreeBrandsList: " + JSON.stringify(brands));
    }
    return brands;
  }

  private buildStepThreeItemsList(selectedItems) {
    // Initialize items list
    const items = [];

    // Add "All" first
    const newSku = new Sku(0, "All");
    const newItem: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, null, newSku);
    newItem._is_all = true;
    items.push(newItem);
    
    // Add selected items (skip "All")
    for (const sku of selectedItems) {
      if (sku.description !== "All") {
        const newSku = new Sku(sku.id, sku.description);
        const newItem = new DistributionPromoDetailSku(0, 0, null, null, newSku);
        items.push(newItem);
      }
    }

    if (environment.showLogs) {
      console.log("buildStepThreeItemsList: " + JSON.stringify(items));
    }
    return items;
  }

  validateMultiSelects() {
    if(!_.get(this.stepTwo.multiSelect, 'selectedCategories').length) {
      this.stepTwo.formGroup.get('category').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedBrands').length) {
      this.stepTwo.formGroup.get('brand').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedItems').length) {
      this.stepTwo.formGroup.get('item').setValue(null);
    }

    if(!_.get(this.stepTwo.multiSelect, 'selectedRegions').length) {
      this.stepTwo.formGroup.get('location_region').setValue(null);
    }

    if(!_.get(this.stepTwo.multiSelect, 'selectedProvinces').length) {
      this.stepTwo.formGroup.get('location_province').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedCities').length) {
      this.stepTwo.formGroup.get('location_city').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedChainTypes').length) {
      this.stepTwo.formGroup.get('chain_type').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedChains').length) {
      this.stepTwo.formGroup.get('chain').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedBranch').length) {
      this.stepTwo.formGroup.get('branch').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedWebUser').length) {
      this.stepTwo.formGroup.get('web_user').setValue(null);
    }
    if(!_.get(this.stepTwo.multiSelect, 'selectedRecipient').length) {
      this.stepTwo.formGroup.get('recipient').setValue(null);
    }
  }

  validateStepThree() {
    if (this.stepThree.formGroupDescription.valid) {
      
      let recievedData: PromoCondition = this.stepThree.condition;
      let distributionPromo: DistributionPromo = new DistributionPromo();
      let distributionDetails = this.campaignsService.getStepTwoResponse();
      let max_qty = this.stepThree.formGroupDescription.controls['maxSKU'].value || null
     
      distributionPromo._id = _.get(this.stepThree, 'distribution_promo_id') || 0; // 0 if new entry
      distributionPromo._distribution_id = distributionDetails.id;
      distributionPromo._max_sku_qty = max_qty
      distributionPromo._max_sku_reset_period = this.stepThree.formGroupDescription.controls['maxSKUresetPeriod'].value || "None"
      distributionPromo._max_sku_reset_period_qty = parseInt(this.stepThree.formGroupDescription.value.maxSKUResetPeriodQty) || null;
      distributionPromo._discount_type_id = parseInt(this.stepThree.formGroupDescription.value.discountTypeSelect);
      distributionPromo._discount_tier = this.stepThree.formGroupDescription.value.discountTier === 'None' ? null : this.stepThree.formGroupDescription.value.discountTier;
      distributionPromo._mechanic_period_basis = this.stepThree.formGroupDescription.value.discountTier === 'period' ? this.stepThree.formGroupDescription.value.mechanicPeriodBasis : null;

      distributionPromo._discount_compute_rounding = _.get(this.stepThree.formGroupDescription, 'value.discountRateSelect') || null;
      distributionPromo._discount_compute_decimal_places = _.get(this.stepThree.formGroupDescription, 'value.decimal') || null;
      distributionPromo._purchase_is_accumulated = this.stepThree.formGroupDescription.value.accumulatedPurchase ? 1 : 0;

      recievedData._distribution_promo = distributionPromo;
      let data = {};
      data["promo_conditions"] = [recievedData];
      
      // 9-jun-2020 kiko HOST EXPECTS 0 for each promoSkuId; process is host will always delete if existing and then insert new records in distribution_promo_detail_sku
      let promoSkus = data["promo_conditions"][0]["distribution_promo_detail"][0]["distribution_promo_sku"];
      promoSkus.forEach(e => {
        e.id = 0;
      })
      
      // Validate that distribution_promo_detail has SKUs, since it is possible that SKUs are deleted in step 2
      const promoConditions = data["promo_conditions"];
      const distributionPromoDetails = promoConditions[0]["distribution_promo_detail"];
      const hasMissingSKUs = distributionPromoDetails.some(detail => 
        !detail["distribution_promo_sku"] || detail["distribution_promo_sku"].length === 0
      );

      if (hasMissingSKUs) {
        this.dialogService.openSnackBar(
          this.languageService.getTranslation("MSG_ERROR_PROMO_CONDITION_MISSING_SKU", {})
        );
        return;
      }

      let loadingDialog = this.dialogService.loading();
      this.listSub = this.campaignsService.postCondition(data)
      // .pipe(
      //   catchError((err) => {
      //     console.error(err);
      //     return observableOf({});
      //   }),
      //   finalize(() => {
      //     loadingDialog.close();
      //     return observableOf({});
      //   }))
        .subscribe(res => {
        if (environment.showLogs) {
          console.log(res);
        }
         loadingDialog.close();
         if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'success') && (_.get(res, 'success.count') > 0)) {
          this.setPromoConditionIds(recievedData, _.get(res.success.results[0], 'details.object'));
          this.save();
        } 
        else if (_.has(res, 'error') && (_.get(res, 'error.count') > 0)) {
          this.dialogService.openSnackBar(_.get(res, 'error.results[0].value'));
        }
        else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_DEFAULT", {}));
        } 
        this.listSub.unsubscribe();
        return observableOf({});
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        loadingDialog.close();
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_DEFAULT", {}));
        this.listSub.unsubscribe();
        return observableOf(null);
      }, () => {
        this.listSub.unsubscribe();
      });
    } else {
      for (let ctrl in this.stepThree.formGroupDescription.controls) {
        this.stepThree.formGroupDescription.controls[ctrl].markAsTouched();
      }
      this.scrollToTop();
    }
  }

  setPromoConditionIds(recievedData, resData) {
    let self = this;
    _.forEach(resData.distribution_promo_detail, function(e, index){
      if(self.stepThree.promoDetails.length){
        self.stepThree.promoDetails[index]._id = e.id
      }
      
      if(_.toLower(e.start_date) == "none") {
        e.start_date = null;
      }
      if(_.toLower(e.end_date) == "none") {
        e.end_date = null;
      }
      if(_.toLower(e.capacity_reset_period_qty) == "none") {
        e.capacity_reset_period_qty = null;
      }
      if(_.toLower(e.mechanic_period) == "none") {
        e.mechanic_period = null;
      }

      e.distribution_promo_sku.forEach(f => {
        if(_.toLower(f.category) == "none") {
          f.category = null;
        }
        if(_.toLower(f.brand) == "none") {
          f.brand = null;
        }
        if(_.toLower(f.sku) == "none") {
          f.sku = null;
        }
      })
    })

    if(_.toLower(_.get(resData.distribution_promo, 'max_sku_qty')) == "none") {
      resData.distribution_promo.max_sku_qty = null;
    }
    if(_.toLower(_.get(resData.distribution_promo, 'max_sku_reset_period_qty')) == "none") {
      resData.distribution_promo.max_sku_reset_period_qty = null;
    }
    if(_.toLower(_.get(resData.distribution_promo, 'discount_compute_rounding')) == "none") {
      resData.distribution_promo.discount_compute_rounding = null;
    }
    if(_.toLower(_.get(resData.distribution_promo, 'discount_compute_decimal_places')) == "none") {
      resData.distribution_promo.discount_compute_decimal_places = null;
    }
    _.assign(recievedData, resData);
    this.stepThree.distribution_promo_id = _.get(resData.distribution_promo, 'id');
  }

  save() {
    this.dialogService
      .openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_WIZARD_SAVE", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          let loadingDialog = this.dialogService.loading();
          let distributionDetails = this.campaignsService.getStepTwoResponse();

          let filter = {
            web_filter: {
                filters: {
                  distribution_id: distributionDetails["id"],
                  generation_type: _.get(this.stepTwo.formGroup.value.generation_type, "code") || _.get(this.stepTwo.formGroup.controls, 'generation_type.value.code')
                }
            }
          };

          this.campaignsService.generateUserRecipientMapping(filter).subscribe(resp => {
            if(environment.showLogs) {
              console.log(resp);
            }
            loadingDialog.close();
            this.dialogRef.close(true);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_CAMPAIGN_SUBMITTED", {}));
          });
        }
      });
  }

  close() {
    this.dialogService
      .openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.viewMode ? this.languageService.getTranslation("MSG_WIZARD_CLOSE", {}) : this.languageService.getTranslation("MSG_WIZARD_CLOSE_WITH_CHANGE", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
      });
  }

  handleSelectionChange(event: StepperSelectionEvent) {
    event.selectedStep.interacted = false;
    this.scrollToTop();
  }

  scrollToTop() {
    const element = document.querySelector(".mat-horizontal-content-container");
    if (element) {
      element.scrollTop = 0;
    }
  }

  confirmBackStepThree(){
    if (!this.stepTwo.viewMode) {
      this.stepTwo.editMode = true;
    }

    this.stepTwo.formGroup.get('code').disable();
    this.disabledByBackBtn = true;

    if(this.stepThree.formGroup.untouched && !this.stepThree.promoDetails.length || this.viewMode) {
      this.stepper.previous();
    } 
    else {
      this.dialogService
      .openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_UNSAVED_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          // console.log(this.disabledByBackBtn);
          //clear selected chips
          this.stepThree.multiSelect.selectedBrands = [];
          this.stepThree.multiSelect.selectedItems = [];
          this.stepThree.items.forEach(e => {
            e.selected = false;
          })
          this.stepThree.brands.forEach(e => {
            e.selected = false;
          })
          this.stepThree.expansionPanel.close();

          if(this.stepThree.formGroupDescription.get('discountTypeSelect').disabled || this.stepThree.formGroup.get('periodTier').disabled) {
            this.stepThree.formGroupDescription.get('discountTypeSelect').enable();
            this.stepThree.formGroup.get('periodTier').enable();
            this.stepThree.mechanicFormArray.reset();
            this.stepThree.mechanicFormArray.markAsUntouched();
            this.stepThree.conditionDetailRows = [];
            this.stepThree.expansionPanel.close();
            this.stepThree.resetForm();
            this.stepThree.formGroup.get('description').reset();
            this.stepThree.formGroup.get('description').markAsUntouched();
            
            // console.log(this.stepThree.mechanicFormArray, this.stepThree.formGroup);
          }
          this.stepper.previous();
        }
      })}
      
      if(this.allCategoriesSelected) {
        this.stepTwo.multiSelect.selectedCategories = [this.stepTwo.defaultOption];
        this.stepTwo.formGroup.get('category').setValue([0], {emitEvent: false});
        this.stepTwo.categorys = [this.stepTwo.defaultOption];
      }

      if(this.allBrandsSelected) {
        this.stepTwo.multiSelect.selectedBrands = [this.stepTwo.defaultOption];
        this.stepTwo.formGroup.get('brand').setValue([0], {emitEvent: false});
        this.stepTwo.brands = [this.stepTwo.defaultOption];
      } 
      if(this.allItemsSelected) {
        this.stepTwo.multiSelect.selectedItems = [this.stepTwo.defaultOption];
        this.stepTwo.formGroup.get('item').setValue([0], {emitEvent: false});
        this.stepTwo.items = [this.stepTwo.defaultOption];
      } 
  }

  autoCompleteFieldOpen() {
    // (_.get(this.stepThree, 'matAutocomplete') && this.stepThree.matAutocomplete.isOpen) || 
    return ((_.get(this.stepTwo, 'categoryACRef') && this.stepTwo.categoryACRef.isOpen) );
    // || (_.get(this.stepTwo, 'brandACRef') && this.stepTwo.brandACRef.isOpen) || (_.get(this.stepTwo, 'itemACRef') && this.stepTwo.itemACRef.isOpen) || (this.stepTwo.regionACRef.isOpen) || (this.stepTwo.provinceACRef.isOpen) || (this.stepTwo.cityACRef.isOpen) || (this.stepTwo.chain_typeACRef.isOpen) || (this.stepTwo.chainACRef.isOpen) || (this.stepTwo.branchACRef.isOpen) || this.stepThree.matAutocomplete.isOpen ||this.stepThree.escCopier.duplicateAC.isOpen || this.campaignSelector.campaignACRef.isOpen || this.distributionSelector.distributionACRef.isOpen) ? true : false;
  }

  getCampaignDetail() {
    this.loadingCampaign = true;

    this.campaignMntService.getDetail({campaign_id: _.get(this.data, "campaign_distribution_data.campaign_id")})
      .pipe(finalize(() => {
        this.loadingCampaign = false;
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }

        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.selectedCampaign = _.get(res, 'data')
        } 
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loadingCampaign = false;
        return observableOf(null);
      });
  }


  getDistributionDetail() {
      this.loadingDistribution = true
      
      let filters = {
        web_filter: {
          distribution_id: _.get(this.data, "campaign_distribution_data.distribution_id")
        }
      }
  
      this.campaignsService.getDistributionDetail(filters)
        .pipe(finalize(() => {
          this.loadingDistribution = false;
        }))
        .subscribe((res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }
          if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
            return;
          }
          if (_.has(res, 'value') && (res.value == "Success")) {
            this.selectedDistribution = _.get(res, 'data')
            this.selectedDistribution.description = _.get(this.data, "campaign_distribution_data.distribution_description")
            this.selectedDistribution.is_cancelled = _.get(this.data, "campaign_distribution_data.distribution_is_active") == 1 ? false : true
          } 
        }, err => {
          if (environment.showLogs) {
            console.error(err);
          }
          this.loadingDistribution = false;
          return observableOf(null);
        });
    }
}
